import type React from 'react';
import { useMemo, type FC } from 'react';
import { useActiveUser } from '@/containers/App';
import { createMongoAbility } from '@casl/ability';
import { unpackRules } from '@casl/ability/extra';
import { AbilityContext } from './AbilityContext';

interface AbilityProviderProps {
  children: React.ReactNode;
}

export const AbilityProvider: FC<AbilityProviderProps> = ({ children }) => {
  const activeUser = useActiveUser();

  const ability = useMemo(() => {
    if (activeUser) {
      // @ts-expect-error unpackRules type is not correct
      return createMongoAbility(unpackRules(activeUser.rules));
    }
    return createMongoAbility();
  }, [activeUser]);

  return <AbilityContext.Provider value={ability}>{children}</AbilityContext.Provider>;
};
